<template>
  <div class="Hzhb-container">
    <div class="Hzhb-title">合作伙伴</div>
    <div class="Hzhb-img-List">
 
      
       
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.Hzhb-title{
    font-family: Medium;
    margin-bottom: 40px;
    font-size:33px ;
    font-weight: 500;
}

.Hzhb-img-List{
    min-width:1200px;
    height: 310px;
    background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B41.png');
    background-size: cover;
      position: relative;
}
.Hzhb-container{
    padding: 100px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

  
}
</style>